<template>
  <main class="ip-whitelist-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <span class="toolbar-title">IP 白名单</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
      </div>
      <div class="toolbar-tip">
        <i class="el-icon-info"></i>
        设置允许访问 API 的 IP 地址或网段（支持 CIDR 格式，如 192.168.1.0/24）。留空表示不限制。
      </div>
      <div class="desktop-only">
        <el-table :data="whitelist" size="small" style="width: 100%" v-loading="loading">
          <el-table-column type="index" label="序号" width="70" :index="pageIndex" />
          <el-table-column prop="ipAddress" label="IP 地址 / 网段" min-width="200">
            <template slot-scope="scope">
              <code style="color:#f4b74f;">{{ scope.row.ipAddress }}</code>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="150">
            <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="onEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="text" class="delete-btn" @click="onDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="mobile-only list-cards">
        <div v-for="item in whitelist" :key="item.id" class="list-card">
          <div class="card-header">
            <code style="color:#f4b74f;font-size:14px;">{{ item.ipAddress }}</code>
          </div>
          <div style="font-size:13px;color:rgba(255,255,255,.6);margin-bottom:8px;" v-if="item.remark">
            {{ item.remark }}
          </div>
          <div class="meta-row">
            <span>{{ $formatTime(item.createdAt) }}</span>
          </div>
          <div class="card-actions">
            <el-button size="small" type="text" @click="onEdit(item)">编辑</el-button>
            <el-button size="small" type="text" class="delete-btn" @click="onDelete(item)">删除</el-button>
          </div>
        </div>
      </div>
    </section>

    <el-dialog :title="form.id ? '编辑 IP 白名单' : '新增 IP 白名单'" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="formRules" label-width="80px" label-position="right" size="small">
        <el-form-item label="IP 地址" prop="ipAddress">
          <el-input v-model="form.ipAddress" placeholder="如 192.168.1.100 或 192.168.1.0/24" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" placeholder="可选，如：办公室 IP" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
export default {
  name: 'IpWhitelistPage',
  data() {
    return {
      whitelist: [],
      loading: false,
      dialogVisible: false,
      submitting: false,
      formRules: {
        ipAddress: [
          { required: true, message: '请输入 IP 地址', trigger: 'blur' }
        ]
      },
      form: {
        id: null,
        ipAddress: '',
        remark: ''
      }
    }
  },
  computed: {
    pageIndex() {
      return 1
    }
  },
  mounted() {
    this.fetchWhitelist()
  },
  methods: {
    async fetchWhitelist() {
      this.loading = true
      try {
        const res = await this.$http.get('/admin/ip-whitelist')
        this.whitelist = res || []
      } catch {
        this.$message.error('加载 IP 白名单失败')
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.form = { id: null, ipAddress: '', remark: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    onEdit(row) {
      this.form = { id: row.id, ipAddress: row.ipAddress, remark: row.remark || '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.form.id) {
            await this.$http.put('/admin/ip-whitelist/' + this.form.id, {
              ipAddress: this.form.ipAddress.trim(),
              remark: this.form.remark || null
            })
            this.$message.success('修改成功')
          } else {
            await this.$http.post('/admin/ip-whitelist', {
              ipAddress: this.form.ipAddress.trim(),
              remark: this.form.remark || null
            })
            this.$message.success('添加成功')
          }
          this.dialogVisible = false
          this.fetchWhitelist()
        } catch {
          this.$message.error(this.form.id ? '修改失败' : '添加失败')
        } finally {
          this.submitting = false
        }
      })
    },
    onDelete(row) {
      this.$confirm('确定删除 IP「' + row.ipAddress + '」？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.delete('/admin/ip-whitelist/' + row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchWhitelist()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.ip-whitelist-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 800;
  color: var(--text);
  flex: 1;
}

.toolbar-tip {
  font-size: 12px;
  color: var(--muted-2, #999);
  margin-bottom: 16px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  border-left: 3px solid #409eff;
}

.toolbar-tip i {
  margin-right: 4px;
  color: #409eff;
}

.delete-btn {
  color: #e74c3c;
}

.list-cards { display: grid; gap: 14px; }
.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .ip-whitelist-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
  }
}

.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}

.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}

.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}
</style>
